// extracted by mini-css-extract-plugin
export default {"search-bar":"SearchBar_search-bar__9529x"};